import React from 'react';
import immJs from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage } from 'react-intl';
import { Button, Icon, Alert } from 'antd';
import './EventToolTipComponent.scss';
import CreateMeetingContainer from '../../Containers/CreateMeeting/CreateMeetingContainer';
import { getParameterValue } from '../../Repositories/CalendarRepository';
import { toInstant } from '../../Utility/proposeLink';

const messages = defineMessages({
  inPerson: {
    id: 'EventToolTip.Text.InPerson',
    defaultMessage: 'In Person',
  },
  onCall: {
    id: 'EventToolTip.Text.OnCall',
    defaultMessage: 'On Call',
  },
});

function AttendeesToString(attendees) {
  let email = '';
  const currentUser = getParameterValue('username');

  attendees.forEach(attendee => {
    let extra;
    if (attendee.Email === currentUser && attendee.Role === "OPT-PARTICIPANT") {
      extra = ' (You, Opt)';
    } else if (attendee.Email === currentUser) {
      extra = ' (You)';
    } else if (attendee.Role === "OPT-PARTICIPANT") {
      extra = ' (Opt)';
    } else {
      extra = '';
    }
    email = `${email + attendee.Email + extra}, `;
  });

  email = email.slice(0, -2);
  return email;
}

function EventToolTipComponent(props) {
  let actions;
  let removeButton;
  let actionButtons;
  const attendees = [];
  const accepted = [];
  const pending = [];
  const declined = [];
  let isLocationPlace;
  const {
    event,
    type,
    deleteEvent,
    recruiterStatus,
    onBlur,
    candidates,
    startTime,
    endTime,
    eventStatusText,
  } = props;

  if (event.Attendees !== undefined) {
    event.Attendees.forEach(attendee => {
      const currentAttendee = {
        Email: attendee.Email,
        Role: attendee.Role,
      };
      attendees.push(currentAttendee);
      switch (attendee.Status) {
        case 'Confirmed':
          accepted.push(currentAttendee);
          break;
        case 'Declined':
          declined.push(currentAttendee);
          break;
        case 'Waiting':
          pending.push(currentAttendee);
          break;
        default:
          pending.push(currentAttendee);
      }
    });
  }

  if (type === 'arya') {
    if (event.Status === 'Declined') {
      removeButton = (
        <Button
          className="actions-button remove-button-tooltip"
          onClick={() => deleteEvent(props.event)}
          style={{ height: 'inherit', verticalAlign: 'middle' }}
        >
          Remove from calendar
        </Button>
      );
    }
    if (event.Status !== 'Declined' && moment(toInstant(event.EndTime)).isAfter(moment())) {
      actionButtons = (
        <React.Fragment>
          <Button
            className={`actions-button ${recruiterStatus === 'confirmed' ? 'yes-button-tooltip' : ''}`}
            onClick={e => {
              props.handleClick(e, 'YES');
            }}
            style={{ height: 'inherit', verticalAlign: 'middle' }}
            disabled={recruiterStatus === 'confirmed'}
          >
            {recruiterStatus === 'confirmed' ? <Icon type="check" /> : null}
            Yes
          </Button>
          <Button
            className="actions-button"
            disabled={recruiterStatus === 'declined'}
            onClick={e => {
              props.handleClick(e, 'NO');
            }}
            style={{ height: 'inherit', verticalAlign: 'middle' }}
          >
            {recruiterStatus === 'declined' ? <Icon type="close" /> : null}
            No
          </Button>
        </React.Fragment>
      );
    }
    actions = (
      <div>
        {/* <span
          className="edit-button-tooltip"
          onClick={e => {
            onBlur(e);
          }}
          role="button"
          tabIndex={0}
          onKeyPress={e => {
            onBlur(e);
          }}
        >
          <CreateMeetingContainer type="edit" event={event} title="Edit" candidates={candidates} />
        </span> */}
        <div className="actions">
          {actionButtons}
          <span
            className="propose-button-tooltip"
            onClick={e => {
              onBlur(e);
            }}
            role="button"
            tabIndex={0}
            onKeyPress={e => {
              onBlur(e);
            }}
          >
            <CreateMeetingContainer type="update" event={event} title="Propose" candidates={candidates} />
          </span>
          {removeButton}
        </div>
      </div>
    );
  }
  if (immJs.get(props, 'event.Location', false)) {
    const pattern = /[A-za-z]/;
    isLocationPlace = pattern.test(event.Location);
  }
  return (
    <div className="event-tool-tip">
      <div className="title">
        <div className="title-text">{event.Summary}</div>
        <div className="event-description" dangerouslySetInnerHTML={{ __html: event.Description }} />
      </div>
      <div className="details">
        <div className="time">
          <Icon type="clock-circle" className="clock-circle-icon" />
          {moment(toInstant(event.StartTime))
            .startOf('day')
            .format('dddd, MMMM Do')}
          , {startTime}-{endTime}
        </div>
        <div className="email">
          <Icon type="mail" className="mail-icon" />
          <div className="email-text">{AttendeesToString(attendees)}</div>
        </div>
        <div className="call">
          <Icon type="phone" className="call-icon" />
          {event.Location}
        </div>
        <div className="event-place">
          <Icon type="environment" className="location-icon" />
          {isLocationPlace ? <FormattedMessage {...messages.inPerson} /> : <FormattedMessage {...messages.onCall} />}
        </div>
        <div className="event-status">
          <Alert
            message={
              <div className="tooltip-status">
                <span style={{ fontWeight: 500 }}>Status: </span>
                <span>{eventStatusText}</span>
              </div>
            }
            type={event.Status !== 'Declined' ? 'success' : 'error'}
          />
        </div>
        <div className="attendees-category">
          {accepted.length ? (
            <div className="event-accepted">
              <div className="event-accepted-status">
                <Icon type="check-circle" className="accepted-icon" theme="filled" />
                <span className="attendees-status">Accepted</span>
              </div>
              <div className="email">{AttendeesToString(accepted)}</div>
            </div>
          ) : null}
          {pending.length ? (
            <div className="event-pending">
              <div className="event-pending-status">
                <Icon type="exclamation-circle" className="pending-icon" theme="filled" />
                <span className="attendees-status">Pending</span>
              </div>
              <div className="email">{AttendeesToString(pending)}</div>
            </div>
          ) : null}
          {declined.length ? (
            <div className="event-declined">
              <div className="event-declined-status">
                <Icon type="close-circle" className="declined-icon" theme="filled" />
                <span className="attendees-status">Declined</span>
              </div>
              <div className="email">{AttendeesToString(declined)}</div>
            </div>
          ) : null}
        </div>
      </div>
      <div className="tooltip-actions">{actions}</div>
    </div>
  );
}

export default EventToolTipComponent;

EventToolTipComponent.propTypes = {
  handleClick: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  deleteEvent: PropTypes.func.isRequired,
  type: PropTypes.string,
  event: PropTypes.shape({
    StartTime: PropTypes.string,
    EndTime: PropTypes.string,
    Summary: PropTypes.string,
    Location: PropTypes.string,
    Status: PropTypes.string,
    Attendees: PropTypes.arrayOf(
      PropTypes.shape({
        Email: PropTypes.string,
        Role: PropTypes.string,
        Status: PropTypes.string
      })
    ),
  }),
  endTime: PropTypes.string,
  startTime: PropTypes.string,
  recruiterStatus: PropTypes.string,
  candidates: PropTypes.arrayOf(
    PropTypes.shape({
      email: PropTypes.string,
      role: PropTypes.string,
      status: PropTypes.String
    })
  ),
};

EventToolTipComponent.defaultProps = {
  type: '',
  event: {
    StartTime: moment().format(),
    EndTime: moment().format(),
    Summary: '',
    Location: '',
    Attendees: [],
    Status: '',
  },
  endTime: moment().format('hh:mm a'),
  startTime: moment().format('hh:mm a'),
  recruiterStatus: '',
  candidates: [],
};
